import { render } from "./layout-header.vue?vue&type=template&id=2c8bcf9c&scoped=true"
import script from "./layout-header.vue?vue&type=script&lang=js"
export * from "./layout-header.vue?vue&type=script&lang=js"

import "./layout-header.vue?vue&type=style&index=0&id=2c8bcf9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8bcf9c"]])

export default __exports__